import React, { Component, Fragment } from 'react';
import { Type } from 'react-spark';
import CreditCardPromoModal from './CreditCardReductionModal';

// Component used for marketing campaigns, meant to be hidden when campaigns are not active
class CreditCardReductionBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldRenderBanner: false,
            isModalOpen: false,
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const currentBannerTimeUTC = Date.now();
        // 03/10/2025 8:00AM ET
        const creditCardReductionStartTimeUTC = Date.UTC(2025, 2, 10, 12, 0, 0, 0);
        // 03/24/2025 11:59PM ET
        const creditCardReductionEndTimeUTC = Date.UTC(2025, 2, 25, 3, 59, 59, 0);
        if (currentBannerTimeUTC >= creditCardReductionStartTimeUTC && currentBannerTimeUTC <= creditCardReductionEndTimeUTC) {
            this.setState({
                shouldRenderBanner: true,
            });
        }
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }
    
    render() {
        const { shouldRenderBanner, isModalOpen } = this.state;


        return shouldRenderBanner && (
            <Fragment>
                <CreditCardPromoModal isOpen={isModalOpen} onClose={this.closeModal} />
                <div className="credit-card-promo-banner">
                    <div className="credit-card-promo-banner-tag">
                        <p style={{ margin: '0' }}>
                            Limited time offer
                        </p>
                    </div>
                    <div>
                        <Type.BodyTwo className="sprk-b-TypeBodyTwo">
                            Close on a personal loan by March 24, 2025 and get a $100 e-gift card to celebrate Credit Card Reduction Day.
                            <sup id='openPromoModal'
                                onClick={this.openModal}
                                style={{ cursor: 'pointer', color: 'black', textUnderlineOffset: '2px', textDecoration: 'underline' }}>
                                <span>&dagger;</span>
                            </sup>
                        </Type.BodyTwo>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default CreditCardReductionBanner;
